import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Outlet } from "react-router-dom";

function PublicRoute() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}>
      <Outlet />
    </GoogleReCaptchaProvider>
  );
}

export default PublicRoute;
